import HTTP from "../../http";

const EMAIL_ENDPOINT = "/email";
const VERIFY_GUEST_USER_TOKEN_ENDPOINT = "/verifyGuestUserToken";

export async function verifyGuestUserToken(token) {
  return await HTTP.post(
    EMAIL_ENDPOINT + VERIFY_GUEST_USER_TOKEN_ENDPOINT,
    { token: token },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
